import script from "./AIAssistantTranscription.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantTranscription.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantTranscription.vue?vue&type=style&index=0&id=67fac517&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67fac517"]])

export default __exports__